import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import MaterialTable from "@material-table/core";
import Footer from "../../../components/shared/Footer";
import * as APIModels from "../../../models";
import { ProcessServerService } from "../../../services/ClientService";

export default function ProcessServerPage() {
    const { active } = useParams<{ active?: string }>();

    const [errorMessage, setErrorMessage] = useState("");

    const never = "never" as const;

    const [columns, setColumns] = useState([
        {
            title: "ID",
            field: "id",
            editable: never,
        },
        {
            title: "Company Name",
            field: "companyName",
        },
        {
            title: "Contact Name",
            field: "contactName",
        },
        {
            title: "Email",
            field: "email",
        },
        {
            title: "Phone Number",
            field: "phoneNumber",
        },
        {
            title: "Active",
            field: "active",
            type: "boolean" as const,
        },
    ]);

    const [data, setData] = useState([] as APIModels.ProcessServer[]);

    const refreshData = () => {
        ProcessServerService.getList({
            active:
                active === "active"
                    ? true
                    : active === "inactive"
                    ? false
                    : undefined,
        }).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    setData(resp.data);
                } else {
                    setData([]);
                }
            },
            (error) => {
                console.log(error);
            }
        );
    };

    const onEdit = (rowdata: APIModels.ProcessServer) => {
        window.location.href = `/admin/processserveredit/${rowdata.id}`;
        console.log(rowdata.id);
    };

    const onDelete = (rowData: APIModels.ProcessServer) => {
        ProcessServerService.delete({
            id: rowData.id!,
        }).then(
            (resp) => {
                if (resp.successful && resp.data) {
                    refreshData();
                } else {
                    setErrorMessage("An error has occurred");
                }
            },
            (error) => {
                setErrorMessage(error);
            }
        );
        if (errorMessage !== "") {
            console.log(errorMessage);
            setErrorMessage("");
        }
    };

    useEffect(() => {
        refreshData();
    }, []);

    return (
        <div className="content">
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="page-title-box page-title-box-alt">
                            <h4 className="page-title">Process Servers</h4>
                            <div className="page-title-right">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">
                                            eFileMadeEasy
                                        </a>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <a href="javascript: void(0);">Admin</a>
                                    </li>
                                    <li className="breadcrumb-item active">
                                        Process Servers
                                    </li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-12">
                        <div style={{ maxWidth: "100%" }}>
                            <MaterialTable
                                columns={columns}
                                data={data}
                                title="Process Servers"
                                options={{
                                    actionsColumnIndex: -1,
                                    pageSizeOptions: [5, 10, 20, 50, 75, 100],
                                }}
                                actions={[
                                    {
                                        icon: "edit",
                                        tooltip: "Edit a process server",
                                        onClick: (event, rowData) =>
                                            onEdit(
                                                rowData as APIModels.ProcessServer
                                            ),
                                    },
                                    {
                                        icon: "delete",
                                        tooltip: "Delete a process server",
                                        onClick: (event, rowData) =>
                                            onDelete(
                                                rowData as APIModels.ProcessServer
                                            ),
                                    },
                                ]}
                                editable={{
                                    onRowAdd: (newData) =>
                                        new Promise((resolve, reject) => {
                                            ProcessServerService.add({
                                                body: newData,
                                            }).then(
                                                (_resp) => {
                                                    refreshData();
                                                    resolve(null);
                                                },
                                                (error) => {
                                                    console.log(error);
                                                    resolve(null);
                                                }
                                            );
                                        }),
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    );
}
